import {
  ChoiceGroup,
  DatePicker,
  DefaultButton,
  Icon,
  Label,
  Panel,
  PanelType,
  PrimaryButton,
  Stack,
} from "@fluentui/react";
import { useCallback } from "react";
import { onFormatDate } from "../../../../utils/helpers/dateHelpers";
import { PanelHeader } from "../../../../components/Panel/PanelHeader";
import { useComboSupervisores } from "../../../../hooks/combosHooks/useComboSupervisores";
import { ComboBoxIDS } from "../../../../components/generic/ComboBoxIDS";
import { useComboEstados } from "../../../../hooks/combosHooks/useComboEstados";
import { useComboTipoEquipo } from "../../../../hooks/combosHooks/useComboTipoEquipo";
import { useComboModelos } from "../../../../hooks/combosHooks/useComboModelos";
import { useComboEquipos } from "../../../../hooks/combosHooks/useComboEquipos";
import { IRequetTableHistorico } from "../../../../Interfaces/IListaVerificacion";
import { useComboGuardias } from "../../../../hooks/combosHooks/useComboGuardias";
import { PanelFooter } from "../../../../components/Panel/PanelFooter";
import { filter } from "d3";
interface IPanelFIltroHistorialAdmin {
  isOpen: boolean;
  onDismiss: () => void;
  onChangeComboBox: (e, o, string) => void;
  onChangeChoiceGroup: (e, o) => void;
  filter: IRequetTableHistorico;
  limpiarFiltro: () => void;
  onSelectDate: (date, string) => void;
  fechasFilter: any;
  buscar: () => void;
}

export const PanelFIltroHistorialAdmin = (
  props: IPanelFIltroHistorialAdmin
) => {

  const limpiarFiltro = () => { 
    props.limpiarFiltro(); 
    limpiarFiltersSupervisores();
    limpiarFiltersTipoEquipo();
    limpiarFiltersModelos();
    limpiarFiltersEquipos();
  }

  const {
    SupervisoresCombo,
    _onkeyUpSearchSupervisores,
    comboBoxRefSupervisores,
    onClickComboSupevisores,
    obtenerPuesto,
    setSearch,
    getComboSupervisores,
    limpiarFilters: limpiarFiltersSupervisores
  } = useComboSupervisores();
  const { comboBoxRefGuardias, dataComboGuardia, onClickOpenGuardias } =
    useComboGuardias();
  const { estados } = useComboEstados();
  const {
    dataComboTipoEquipos,
    comboBoxRefTipoEquipo,
    onClickComboTipoEquipo,
    _onkeyUpSearchTipoEquipo,
    limpiarFilters: limpiarFiltersTipoEquipo,
  } = useComboTipoEquipo();

  const {
    dataComboModelos,
    onClickComboModelos,
    _onkeyUpSearchDispositivo,
    comboBoxRefModelos,
    limpiarFilters: limpiarFiltersModelos,
  } = useComboModelos();
  const {
    dataCombo,
    _onkeyUpSearchEquipo,
    comboBoxRefEquipoModelo,
    onChangeModelo,
    onClickCamboEquipo,
    setFilter,
    limpiarFilters: limpiarFiltersEquipos,
  } = useComboEquipos();


  const onRenderFooterPanel = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Buscar"
          texto2={"Limpiar"}
          onClick={props.buscar}
          disableButton={false}
          onDismiss={limpiarFiltro}
        />
      </>
    ),
    [props.onDismiss, props.limpiarFiltro]
  );

  const onRenderHeaderPanel = useCallback(
    () => (
      <PanelHeader
        textHeader="Filtro Avanzado Historial de Checklist"
        subTextHeader={`Búsqueda Avanzada`}
      />
    ),
    []
  );

  return (
    <Panel
      isOpen={props.isOpen}
      onDismiss={props.onDismiss}
      onRenderFooter={onRenderFooterPanel}
      onRenderHeader={onRenderHeaderPanel}
      isFooterAtBottom={true}
      isBlocking={false}
      closeButtonAriaLabel="Close"
      type={PanelType.medium}
      isLightDismiss
    >
      <br />
      <div className="ms-Grid" dir="ltr">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
            <DatePicker
              label="Fecha de:"
              placeholder="dd/mm/yyyy"
              ariaLabel="Seleccione una fecha"
              value={props.fechasFilter?.filterFechaInicio}
              onSelectDate={(date?: any) => {
                props.onSelectDate(date, "inicio");
              }}
              formatDate={onFormatDate}
              maxDate={new Date()}
              underlined
            />
          </div>
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
            <DatePicker
              label="Fecha a:"
              placeholder="dd/mm/yyyy"
              ariaLabel="Seleccione una fecha"
              value={props.fechasFilter?.filterFechaFin}
              onSelectDate={(date?: any) => {
                props.onSelectDate(date, "fin");
              }}
              formatDate={onFormatDate}
              minDate={props.fechasFilter?.filterFechaInicio}
              maxDate={new Date()}
              underlined
            />
          </div>
        </div>
        <br />
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
            <ComboBoxIDS
              title="Supervisor:"
              componentRef={comboBoxRefSupervisores}
              selectedKey={props.filter?.supervisorId}
              KeyUp={_onkeyUpSearchSupervisores}
              onChange={(e, o) => {
                props.onChangeComboBox(e, o, "supervisor");
              }}
              styles={{ optionsContainer: { maxHeight: 200 } }}
              onClick={onClickComboSupevisores}
              options={SupervisoresCombo}
              onRenderOption={(option) => (
                <>
                  {option && (
                    <div>
                      <span>{option?.text}</span>
                      <br />
                      <span
                        style={{
                          paddingBottom: "0.9px",
                          color: "#777",
                          fontSize: "0.7rem",
                        }}
                      >
                        {obtenerPuesto(option?.key)}
                      </span>
                    </div>
                  )}
                </>
              )}
            />
          </div>
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
            <ComboBoxIDS
              title="Guardia:"
              componentRef={comboBoxRefGuardias}
              selectedKey={props.filter?.guardia}
              onChange={(e, o) => {
                props.onChangeComboBox(e, o, "guardia");
              }}
              onClick={onClickOpenGuardias}
              options={dataComboGuardia}
              styles={{ optionsContainer: { maxHeight: 200 } }}

            />
          </div>
        </div>
        <br />
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
            <Label id="labelElement">
              <Stack horizontal verticalAlign="center">
                <span>Estados&nbsp;&nbsp;</span>
                <Icon iconName="Filter" />
              </Stack>
            </Label>
            <ChoiceGroup
              options={estados}
              selectedKey={props.filter?.estadoId}
              onChange={(e, o) => props.onChangeChoiceGroup(e, o)}
              ariaLabelledBy="labelElement"
            />
          </div>
        </div>
        <br />
        {/* <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
            <ComboBoxIDS
              title="Tipo Equipo:"
              componentRef={comboBoxRefTipoEquipo}
              selectedKey={props.filter?.tipoEquipoId}
              onChange={(e, o) => {
                props.onChangeComboBox(e, o, "tipoEquipo");
              }}
              KeyUp={_onkeyUpSearchTipoEquipo}
              onClick={onClickComboTipoEquipo}
              options={dataComboTipoEquipos}
            />
          </div>
        </div> */}
        {/* <br /> */}
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
            <ComboBoxIDS
              title="Modelo Equipo:"
              componentRef={comboBoxRefModelos}
              KeyUp={_onkeyUpSearchDispositivo}
              selectedKey={props.filter?.equipoModeloId}
              onClick={onClickComboModelos}
              options={dataComboModelos}
              onChange={(e, o) => {
                props.onChangeComboBox(e, o, "modeloEquipo");
                onChangeModelo(e, o);
              }}
              styles={{ optionsContainer: { maxHeight: 200 } }}

            />
          </div>
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
            <ComboBoxIDS
              title="Equipo:"
              componentRef={comboBoxRefEquipoModelo}
              KeyUp={_onkeyUpSearchEquipo}
              selectedKey={props.filter.equipoId}
              onChange={(e, o) => {
                props.onChangeComboBox(e, o, "equipo");
              }}
              onClick={onClickCamboEquipo}
              options={dataCombo}
              styles={{ optionsContainer: { maxHeight: 200 } }}
            />
          </div>
        </div>
      </div>
    </Panel>
  );
};
